import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';
import { Password } from "primereact/password";
import fileSaver from 'file-saver'



export default function DownloadSmsSenderApk(props) {
  const toast = useRef(null);
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);


  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");


  useEffect(() => {
  }, []);

  return (
    <>

      <div style={{ width: "100%", boxSizing: "border-box", padding: "20px" }}>
        <table style={{ width: "100%", minWidth: "250px", maxWidth: "350px", marginLeft: "auto", marginRight: "auto" }}>
          <tbody>
            <tr>
              <td style={{ width: "100%", textAlign: "center" }}><span style={{ fontSize: "4em", textAlign: "center" }} className="pi pi-mobile"></span></td>
            </tr>
            <tr>
              <td style={{ fontSize: "1.5em", textAlign: "center" }}>دانلود اپلیکیشن ارسال پیامک</td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
              <td style={{ fontSize: "1.5em", textAlign: "center", direction: "ltr" }}>
                  <div className="flex align-items-center" style={{ marginTop: "10px", maxWidth: "300px", marginRight: "0px", direction: "ltr" }}>
                    <Button label="دانلود اپلیکیشن اندروید" icon="pi pi-android" onClick={() => { fileSaver.saveAs("https://Classico7.ir/asset/classico7-sms-sender.apk") }} iconPos="right" severity="primary" />
                  </div>

              </td>
            </tr>
            <tr>
              <td style={{ fontSize: "1.5em", textAlign: "center", direction: "ltr" }}>
                  <a href='https://Classico7.ir/asset/classico7-sms-sender.apk' download="classico7-sms-sender.apk" target="_blank">لینک دوم دانلود</a>

              </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
              <td style={{ fontSize: "1.5em", textAlign: "center", direction: "ltr" }}>
                  نسخه مخصوص اندرویدهای قدیمی
              </td>
            </tr>
            <tr>
              <td style={{ fontSize: "1.5em", textAlign: "center", direction: "ltr" }}>
                  <div className="flex align-items-center" style={{ marginTop: "10px", maxWidth: "300px", marginRight: "0px", direction: "ltr" }}>
                    <Button label="دانلود اپلیکیشن اندرویدهای قدیمی" icon="pi pi-android" onClick={() => { fileSaver.saveAs("https://Classico7.ir/asset/classico7-sms-sender-old-android.apk") }} iconPos="right" severity="primary" />
                  </div>

              </td>
            </tr>
            <tr>
              <td style={{ fontSize: "1.5em", textAlign: "center", direction: "ltr" }}>
                  <a href='https://Classico7.ir/asset/classico7-sms-sender-old-android.apk' download="classico7-sms-sender.apk" target="_blank">لینک دوم دانلود اندرویدهای قدیمی</a>

              </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
          </tbody>
        </table>
      </div>
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <Toast ref={toast} />
    </>
  );

}
